<template>
  <div class="pointer wrap" @click="clickCard">
    <div
      class="skill-img"
      :style="{
        backgroundImage: `url(${info.gameImageUrl})`,
      }"
    />
    <div class="skill-info">
      <div class="skill-name">{{ info.gameName }}</div>
      <div v-if="info.status === 'Checking'" class="skill-state">{{$t('upgrade_page_views_dashboard_skills_skill_submit_card_1382')}}</div>
      <div v-else-if="info.status === 'Checked'" class="skill-state">
        <span>{{$t('upgrade_page_views_dashboard_skills_skill_card_1507')}}</span>
        <fps-icon type="arrow-right" size="18" />
      </div>
      <div v-else-if="info.status === 'Fail'" class="skill-state">
        <span>{{$t('upgrade_page_views_dashboard_skills_skill_card_1508')}}</span>
        <fps-icon type="arrow-right" size="18" />
      </div>
      <div v-else-if="info.status === 'Success'" class="skill-state">
        <span class="price">{{ info.price }}</span>
        <span class="unit">{{$t('upgrade_page_views_order_components_order_info_302', [ info.salesUnit | salesUnitTranslate ])}}</span>
      </div>
      <div v-if="info.status === 'Success'" class="order-state">
        <span>{{ info.settingStatus === 'OPEN' ? $t('upgrade_page_views_dashboard_skills_skill_card_1509') : $t('upgrade_page_views_dashboard_skills_skill_card_1510') }}</span>
      </div>
    </div>
    <fps-switch
      v-if="info.status === 'Success'"
      class="switch"
      :value="info.settingStatus === 'OPEN'"
      :loading="loading"
      @change="changeStatus"
    />
    <div v-if="info.status === 'Fail'" class="delete-skill" @click.stop="deleteSkill">
      <fps-icon class="delete-icon" type="close" size="8" />
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
export default {
  props: {
    info: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    clickCard() {
      const { status, id } = this.info
      switch (status) {
        case 'Checking': {
          this.$router.push({
            path: '/settled',
            query: {
              type: 'checking',
            }
          })
          break
        }
        case 'Fail': {
          this.$router.push({
            path: '/settled',
            query: {
              type: 'reapply',
              id,
            }
          })
          break
        }
        case 'Checked':
        case 'Success': {
          this.$router.push({
            path: '/player/skill/detail',
            query: {
              skillId: this.info.id,
              gameId: this.info.gameId,
            }
          })
          break
        }
      }
    },
    changeStatus() {
      const { settingStatus, id } = this.info
      if (settingStatus === 'SYSTEM_CLOSE') {
        this.$message(i18n.t('upgrade_page_views_dashboard_skills_skill_card_1511'))
        return
      }
      if (this.loading) return
      this.loading = true
      const status = settingStatus === 'CLOSE' ? 'OPEN' : 'CLOSE'
      this.$http.post('/player/skill/certification/save', {
        settingStatus: status,
        skillId: id,
      }).then(() => {
        this.$emit('changeStatus', { status, skill: this.info })
        this.loading = false
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    deleteSkill() {
      this.$confirm({
        content: i18n.t('upgrade_page_views_dashboard_skills_skill_card_1512'),
        confirmButtonText: i18n.t('upgrade_page_layout_header_45'),
        cancelButtonText: i18n.t('upgrade_page_views_dashboard_skills_skill_card_1513'),
      }).then(() => {
      }).catch(() => {
        this.$http.post('/player/skill/certification/delete', { skillId: this.info.id })
          .then(() => {
            this.$message.success(i18n.t('upgrade_page_views_user_info_index_743'))
            this.$emit('deleteSkill')
          })
          .catch(() => {
            this.$message.error(i18n.t('upgrade_page_views_user_info_index_744'))
          })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .wrap {
    position: relative;
    .delete-skill {
      position: absolute;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 4px;
      right: 4px;
      // .delete-icon {
      //   height: 12px;
      // }
    }
  }
  .switch {
    align-self: flex-start;
    margin-bottom: 1px;
  }
  .skill-img {
    width: 72px;
    height: 68px;
    background: #fff no-repeat top center / 100%;
    border-radius: 8px;
    margin-right: 12px;
  }
  .skill-info {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    .skill-name {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: $color-gray-1;
    }
    .skill-state {
      display: flex;
      margin-top: 6px;
      align-items: center;
      color: $color-link;
      .price {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: $color-gray-2;
      }
      .unit {
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-2;
        margin-left: 2px;
      }
    }
    .order-state {
      margin-top: 4px;
      font-size: 12px;
      line-height: 18px;
      color: $color-gray-2;
    }
  }
</style>
